// Bashkir translations
export const ba: Record<string, string> = {
  'menu.dashboard': 'Идарә панеле',
  'menu.customers': 'Клиенттар',
  'menu.products': 'Продукттар',
  'menu.users': 'Ҡулланыусылар',
  'menu.settings': 'Көйләүҙәр',
  'menu.logout': 'Сығыу',
  'dashboard.title': 'Идарә панеле',
  'dashboard.newOrder': 'Яңы заказ',
  'order.title': 'Яңы заказ',
  'order.customer': 'Клиент',
  'order.products': 'Продукттар',
  'order.total': 'Барыһы',
  'users.title': 'Ҡулланыусылар',
  'users.name': 'Исем',
  'users.email': 'Электрон почта',
  'common.yes': 'Эйе',
  'common.no': 'Юҡ',
  'common.cancel': 'Баш тартыу',
  'common.save': 'Һаҡлау',
  'common.search': 'Эҙләү',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Керү',
  'login.welcome': 'Рәхим итегеҙ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Электрон почта',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Отчёттар һәм бухгалтерия',
  'menu.systemAndCommunication': 'Система һәм элемтә',
};